<template>
  <el-dialog
    title="新增成员"
    :before-close="closeSyncDialog"
    :visible.sync="showDialog"
    append-to-body
    width="600px"
  >
    <div>
      <el-form
        ref="form"
        :model="form"
        label-position="top"
      >
        <el-form-item
          v-if="employeeStatus"
          label="选择成员类型"
          prop="resource"
        >
          <el-radio-group v-model="form.employee_status">
            <el-radio label="1">
              员工
            </el-radio>
            <div class="tips">
              公司内部销售成员，可与客户绑定专属关系，可根据阶梯式业绩达成计算提成
            </div>
            <div class="divider" />
            <el-radio label="2">
              编外
            </el-radio>
            <div class="tips">
              外部运营服务、代销成员，按照固定业绩比例统一提成
            </div>
            <div class="divider" />
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="选择成员角色"
          prop="resource"
        >
          <el-radio-group v-model="form.special_identity">
            <el-radio label="0">
              导购
            </el-radio>
            <div class="tips">
              可管理本人客户，查看本人销售业绩，执行任务及
            </div>
            <div class="divider" />
            <el-radio label="1">
              店长
            </el-radio>
            <div class="tips">
              包含导购所有权限，并可查看本门店销售业绩，分配本门店离职导购客户
            </div>
            <div class="divider" />
            <!-- <el-radio label="2">
              运营主管
            </el-radio>
            <div class="tips">
              仅查看指定销售组织的销售业绩
            </div>
            <div class="divider" /> -->
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        class="m-r-6"
        @click="closeSyncDialog"
      >取 消</el-button>
      <el-button
        type="primary"
        :loading="syncLoading"
        @click="submitSync"
      >确认同步</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'SpChooseSalespersonType',
  model: {
    prop: 'showDialog',
    event: 'showDialogChange'
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    employeeStatus: {
      type: Boolean,
      default: false
    },
    specialIdentity: {
      type: String,
      default: '0'
    }
  },
  data () {
    return {
      form: {
        employee_status: '1',
        special_identity: '0'
      },
      syncLoading: false
    }
  },
  watch: {
    showDialog (val) {
      if (val) {
        this.form.special_identity = this.specialIdentity
      }
    }
  },
  methods: {
    closeSyncDialog () {
      this.$emit('showDialogChange', false)
    },
    submitSync () {
      this.$emit('chooseType', this.form)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-radio-group {
  width: 100%;
}
.tips {
  line-height: 30px;
  font-size: 12px;
}
.divider {
  width: 100%;
  height: 1px;
  background-color: #dcdfe6;
  margin: 12px 0;
}
</style>
